export default {
  methods: {
    getImageUrl (path) {
      const baseUrl = process.env.VUE_APP_API_BASE_URL
      return `${baseUrl}/${path}`
    }
  }
}
